export default __webpack_public_path__ + "static/media/metamask.3451bfb6.png";